var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVolumeMuteLight = function SvgIconVolumeMuteLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.442 34.64-8.69-6.32a1.1 1.1 0 0 0-.65-.21h-2.62a2.34 2.34 0 0 1-2.34-2.34V23.1a2.34 2.34 0 0 1 2.34-2.34h2.67c.234.002.462-.072.65-.21l.22-.15-1.87-1.84h-1.65a4.55 4.55 0 0 0-4.54 4.54v2.67a4.55 4.55 0 0 0 4.54 4.54h2.26l8.39 6.14a2.29 2.29 0 0 0 1.32.43 2.17 2.17 0 0 0 1-.25 2.22 2.22 0 0 0 1.23-2v-3.46l-2.25-2.25-.01 5.72Zm1-22.37a2.22 2.22 0 0 0-2.29.18l-7.12 5.18 1.59 1.59 6.9-4.95v11.81l2.24 2.24V14.27a2.22 2.22 0 0 0-1.28-2h-.04Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m34.654 38.037-23.71-23.72 1.556-1.555 23.71 23.72-1.556 1.555Z",
    fill: "#000"
  })));
};
export default SvgIconVolumeMuteLight;